// extracted by mini-css-extract-plugin
var _1 = "NarrowSection-ON1h5";
var _2 = "NoBottomSpace-wBU2x";
var _3 = "NoPadding-Tjpkd";
var _4 = "NoSpace-URBNp";
var _5 = "NoTopSpace-cJNVk";
var _6 = "Section-cR5eG";
var _7 = "VariantDarkGreen-B8FBN";
var _8 = "VariantMistyGreen-lw4Il";
var _9 = "VariantPurple-D8I3x";
var _a = "VariantSandstone-hMyWT";
var _b = "VariantSandstoneLight-WSFvl";
export { _1 as "NarrowSection", _2 as "NoBottomSpace", _3 as "NoPadding", _4 as "NoSpace", _5 as "NoTopSpace", _6 as "Section", _7 as "VariantDarkGreen", _8 as "VariantMistyGreen", _9 as "VariantPurple", _a as "VariantSandstone", _b as "VariantSandstoneLight" }
